import React from 'react';
import LegalFooter from '../components/LegalFooter';
import './TermsConditionsPage.css';

const TermsConditionsPage = () => {
  const lastUpdated = 'April 12, 2026';

  return (
    <div className="terms-page">
      <div className="terms-container">
        <header className="terms-header">
          <h1>Terms and Conditions</h1>
          <p>Last updated: {lastUpdated}</p>
        </header>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using Reelo, you agree to these Terms and Conditions. If you do not
            agree, please do not use the platform.
          </p>
        </section>

        <section>
          <h2>2. Eligibility and Accounts</h2>
          <ul>
            <li>You must be at least 13 years old to use Reelo.</li>
            <li>You must provide accurate account information.</li>
            <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
            <li>You are responsible for activity that occurs under your account.</li>
          </ul>
        </section>

        <section>
          <h2>3. Platform Usage</h2>
          <ul>
            <li>Use the platform only for lawful purposes.</li>
            <li>Do not attempt to disrupt, abuse, or interfere with platform operations.</li>
            <li>
              Do not upload or share content that infringes intellectual property or violates the
              rights of others.
            </li>
            <li>
              Do not use bots, fake engagement, paid manipulation, or any artificial methods to
              influence competition outcomes.
            </li>
          </ul>
        </section>

        <section>
          <h2>4. Competitions and Submissions</h2>
          <p>
            Competition rules, eligibility, scoring, and rewards may vary by competition. You agree
            to follow the specific rules posted for each competition.
          </p>
          <p>
            Scoring and ranking may include factors such as views, likes, comments, and creator
            size. Reelo may apply normalization logic to support fair opportunities for new and
            emerging creators.
          </p>
          <p>
            Reelo has final authority over competition decisions, including rankings, winners,
            verification outcomes, and dispute resolution.
          </p>
        </section>

        <section>
          <h2>5. User Content and Intellectual Property</h2>
          <p>
            You retain ownership of content you submit. You must ensure you have all rights,
            licenses, and permissions needed to submit and share that content.
          </p>
          <p>
            By submitting content, you grant Reelo a limited, non-exclusive license to host,
            display, process, feature, and promote the content for operating competitions and
            platform features.
          </p>
        </section>

        <section>
          <h2>6. Third-Party Platform Dependency</h2>
          <p>
            Reelo may rely on third-party platforms (such as YouTube) for submitted content,
            metrics, and related services. We do not control these platforms and are not
            responsible for their availability, policy changes, or data accuracy.
          </p>
        </section>

        <section>
          <h2>7. Rewards and Incentives</h2>
          <p>
            Rewards or incentives are subject to eligibility checks, policy compliance, and
            verification of competition results.
          </p>
          <p>
            Reelo may withhold, modify, replace, or cancel rewards in edge cases, including fraud,
            manipulation, technical errors, policy violations, or incorrect result calculations.
          </p>
        </section>

        <section>
          <h2>8. Suspension and Termination</h2>
          <p>
            We may suspend, restrict, or terminate access to any account at our discretion if we
            detect misuse, policy violations, suspected fraud, or behavior that harms the platform
            or other users.
          </p>
        </section>

        <section>
          <h2>9. Disclaimers and Limitation of Liability</h2>
          <p>
            The platform is provided on an "as is" and "as available" basis. To the maximum extent
            permitted by law, Reelo is not liable for indirect, incidental, special, or
            consequential damages arising from your use of the platform.
          </p>
          <p>
            Reelo does not guarantee channel growth, audience outcomes, revenue, or any specific
            performance result from platform participation.
          </p>
        </section>

        <section>
          <h2>10. Dispute Handling</h2>
          <p>
            If you have a dispute related to competitions, rewards, or account actions, contact us
            first so we can review and resolve it in good faith. Reelo's decision on competition
            outcomes and rankings remains final.
          </p>
        </section>

        <section>
          <h2>11. Governing Law</h2>
          <p>
            These Terms are governed by the laws of India.
          </p>
        </section>

        <section>
          <h2>12. Changes to Terms</h2>
          <p>
            We may update these terms from time to time. Continued use of the platform after updates
            means you accept the revised terms.
          </p>
        </section>

        <section>
          <h2>13. Contact</h2>
          <p>
            For legal or terms-related questions, contact us at <a href="mailto:legal@reelo.co.in">legal@reelo.co.in</a>.
          </p>
        </section>

        <footer className="terms-footer">
          <LegalFooter showBackToLogin />
        </footer>
      </div>
    </div>
  );
};

export default TermsConditionsPage;
